import { Button, Grid, Typography } from '@mui/material';
import { Box } from '@mui/system';
import React from 'react';
import bannerImage from '../../../images/home-banner-image.png';
import bannerBg from '../../../images/Pattern.png';
import imageBg from '../../../images/Group 14948.png';
import homeHeaderBg from '../../../images/hone-banner-bg.png';
import './HomeTopBanner.css'

const imageRightBg = {
    backgroundImage: `url(${bannerBg})`,
    backgroundPosition: 'right bottom',
    backgroundRepeat: 'no-repeat',
    paddingBottom: '4%',
    backgroundSize: '140px 150px'
}
const imageLeftBg = {
    backgroundImage: `url(${imageBg})`,
    backgroundPosition: 'left bottom',
    backgroundRepeat: 'no-repeat',
    paddingBottom: '8%',
    paddingLeft: '8.5%'
}
const headerBg = {
    backgroundImage: `url(${homeHeaderBg})`,
    backgroundPosition: 'left top',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    paddingBottom: '3%',
    paddingLeft: '7%'
}

const HomeTopBanner = () => {
    return (
        < >
            <Grid container sx={{ mt: 2 }} spacing={2}>
                <Grid item sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', textAlign: 'start' }} xs={12} md={6}>
                    <Box id="banner-space">
                        <Box style={headerBg}>
                            <Box sx={{ pl: { sm: 3, md: 5, xl: 25 } }}>
                                <Box id="home-banner-textBg">
                                    <Typography variant="h3" id="banner-text" sx={{ pt: 6, pb: 6, pl: 4 }} style={{ color: '#000D83', fontWeight: 600 }}>
                                        Bringing Your Ideas <br /> To Digital Life
                                    </Typography>
                                </Box>
                            </Box>
                        </Box>
                        <Box sx={{ pl: { md: 14, xl: 40 }, px: { xs: 3, sm: 5 } }}>
                            <Typography variant="p" sx={{ color: '#5B5B5B', fontSize: '18px' }} id="quote-button">
                                Lorem ipsum dolor sit amet, consectetur adipiscing Amet pharetra, maecena. consectetur adipiscing Amet pharetra, maecena.
                            </Typography>
                            <Box sx={{ mt: 5 }}>
                                <Button sx={{ textDecoration: 'none', fontSize: '13px', lineHeight: '15px', color: "#000D83", fontWeight: 600, width: '134px', height: '36px', border: '1px solid #000D83', mr: 3 }} style={{ textTransform: 'capitalize' }} id="button-show">
                                    Get A Quote
                                </Button>
                                <Button sx={{ textDecoration: 'none', fontSize: '13px', lineHeight: '15px', color: "#000D83", fontWeight: 600, width: '134px', height: '36px', border: '1px solid #000D83' }} style={{ textTransform: 'capitalize' }} id="button">
                                    Get A Callback
                                </Button>
                            </Box>
                        </Box>
                    </Box>
                </Grid>
                <Grid item xs={12} md={6}>
                    <Box style={imageRightBg}>
                        <Box style={imageLeftBg}>
                            <img style={{ width: '100%' }} id="image-size" src={bannerImage} alt="" />
                        </Box>
                    </Box>
                </Grid>
            </Grid>
        </>
    );
};

export default HomeTopBanner;